import posthog, { type PostHogInterface } from "posthog-js";
import { environment } from "@/config/environment";

declare const __APP_VERSION__: string;

const POSTHOG_US_HOST = "https://us.i.posthog.com";

function getPostHogEnvironment(): string {
  return environment.ENVIRONMENT;
}

function isSessionRecordingEnabled(): boolean {
  return environment.PROD;
}

export function isPostHogEnabled(): boolean {
  return !!environment.POSTHOG_KEY;
}

export function getPostHogInstance() {
  return posthog;
}

const sharedOptions = {
  api_host: environment.POSTHOG_HOST || POSTHOG_US_HOST,
  person_profiles: "identified_only" as const,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: true,
  persistence: "localStorage+cookie" as const,
  disable_session_recording: !isSessionRecordingEnabled(),
};

/**
 * Options for @posthog/react PostHogProvider (single init — do not also call posthog.init elsewhere).
 */
export function getPostHogProviderOptions() {
  return {
    ...sharedOptions,
    loaded: (ph: PostHogInterface) => {
      const env = getPostHogEnvironment();
      ph.register({
        environment: env,
        app_version: typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "unknown",
      });
      ph.setPersonProperties({ environment: env });
    },
  };
}

/** @deprecated Use getPostHogProviderOptions() for init; this omits the `loaded` callback. */
export const postHogOptions = sharedOptions;
